import appGlobalScript from '/Volumes/projectes/forms-reactive/forms-reactive-1.5/node_modules/@ionic/core/dist/collection/global/ionic-global.js';
export const globalScripts = appGlobalScript;
